import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200/50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h4 className="font-heading text-lg font-bold text-foreground-900 mb-4">
              <Link to="/" className="hover:text-primary-500 transition-colors duration-200">
                Basetao<span className="text-primary-500">Sheet</span>
              </Link>
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Your trusted resource for Basetao Spreadsheet guides, product reviews, shipping tips, and smart shopping insights.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/basetao-spreadsheet-guide-2026" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Complete Guide 2026
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Reviews
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Shipping Info
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">Top Categories</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Shoes
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Hoodies &amp; Sweaters
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  T-Shirts
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-921/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Bags
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">Resources</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Main Website
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Coupons &amp; Deals
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Warehouse Guide
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Shipping Calculator
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-secondary-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} BasetaoSheet. All rights reserved. This is an independent educational resource.
          </p>
          <div className="flex items-center gap-5">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
              Disclaimer
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
              Privacy
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}